import { render } from "./SourceCodeViewer.vue?vue&type=template&id=5443c40c&ts=true"
import script from "./SourceCodeViewer.vue?vue&type=script&lang=ts"
export * from "./SourceCodeViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__